import React from 'react';
import { useAppSelector } from '@store/hooks';

import BalanceDetailsControl from '@flp/components/balances/balance-details-control';

import { IUserSession } from '@entities/user-session';

import { UserBalanceType } from '@src/core/enums/user-balance-type';
import IBaseComponentProps from '@src/core/components/base-component-props';

interface IBalanceDetailsProps extends IBaseComponentProps {
    userBalanceType: UserBalanceType;
}

const BalanceDetails = (props: IBalanceDetailsProps) => {
    const { serverFetch, userBalanceType } = props;

    const userSession = useAppSelector<IUserSession>((s) => s.userSession);

    return (
        <BalanceDetailsControl
            userId={userSession.userId}
            userBalanceType={userBalanceType}
            isViewMode={true}
            showExchangeRateInfo={false}
            useTagRequired={userSession.useTagRequired}
            tag={userSession.tag}
            serverFetch={serverFetch}
        />
    );
};

export default BalanceDetails;
